import React from 'react';
import Helpers from './Helpers.js'

import './Legend.css';


class Legend extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		}
		this.items = [
			{
				id: "Democratic Party",
				label: "Demokraten",
				code: "D"
			},
			{
				id: "Republican Party",
				label: "Republikaner",
				code: "R"
			},
			{
				id: "Andere",
				label: "Andere",
				code: "others"
			},
			// {
			// 	id: "unassigned",
			// 	label: "Unzugeteilt",
			// 	code: "unassigned"
			// }
		]
			
	}
		

	render() {
		if(this.props.show==="result") {
			return(
					
				<div className = 'Legend'>
					{						
							this.items.map((v,i) => {
								return(
									<div className={'legendItem '+v.code} key={i}>
										<div className='legendIcon'></div>
										<div className='legendValue'>{v.label}</div>
									</div>
								)
							})						
						}	
				</div>
			)
		}		
		else if(this.props.show==="polls") {
			return(
					
				<div className = 'Legend'>
					{						
						Helpers.o2a(this.props.polls).items.map((poll,k) => {
								return(
									<div className={'legendItem '+poll.id} key={k}>
										<div className='legendIcon'></div>
										<div className='legendValue'>{poll.label}</div>
									</div>
								)
							})						
						}	
				</div>
			)
		}
	}
}

export default Legend
